import { action, observable, makeObservable } from 'mobx';
import axios from 'axios';

const { REACT_APP_API_URL } = process.env;

class ServiceStatusesStore {
  constructor(profileStore) {
    makeObservable(this, {
      serviceStatuses: observable,
      loadingServiceStatuses: observable,
      error: observable,
      getServiceStatuses: action,
      resetServiceStatuses: action
    });

    this.profileStore = profileStore;
  }

  serviceStatuses = [];

  loadingServiceStatuses = true;

  error = '';

  getServiceStatuses = async () => {
    const authToken = await this.profileStore.getAuthToken();
    this.error = '';

    try {
      const { data } = await axios.get(`${REACT_APP_API_URL}/status`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      this.serviceStatuses = data;
    } catch (err) {
      this.error = err.message;
      this.serviceStatuses = [];
      this.loadingServiceStatuses = false;
    }
  };

  resetServiceStatuses = () => {
    this.serviceStatuses = [];
    this.error = '';
  };
}

export default ServiceStatusesStore;
